export const FEATURE_NAME = 'init'

export const DEFAULT_TITLE_FONT_SIZE = 34

export interface IState {
  title: string | null
  titleFontSize: number
  seeAllScoresButton: boolean
  hideEmptyResults: boolean
  backgroundImage: string | null
}
